export function Divider() {
  return <div className="self-stretch mx-4 w-1 bg-divider flex-shrink-0" />;
}
